import React, { useEffect, useState, useRef } from "react";
import { Col, Row, Card, CardText, Form, CardBody } from "reactstrap";
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import readXlsxFile from "read-excel-file";
import { importSchedule } from "../../../utils/services/schedule";
import ModeloUpload from "../../../assets/statics/modelo_agenda.xlsx";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
import {
  allExcelColumns,
  excelColumnsPtBr,
  getValidateAgenda,
} from "./importScheduleValidation";
import ModalExcelRows from "./ModalExcelRows";

import moment from "moment";

export default function ImportSchedule(props) {
  const { isOpen, toggle, idEvent, token } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  const [selectedFiles, setselectedFiles] = useState([]);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [imgError, setImgError] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  const importActivated = useRef(false);

  // modal de erros no arquivo xlsx
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);

  const timerID = useRef(null);

  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  useEffect(() => {
    setselectedFiles([]);
    setImgError("");
  }, [isOpen]);

  function handleAcceptedFiles(files) {
    files.forEach((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
    clearTimeout(timerID.current);
  }
  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    importActivated.current = true;
    clearTimeout(timerID.current);
    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      Titulo: {
        prop: "title",
        type: String,
      },
      Descricao: {
        prop: "description",
        type: String,
      },
      DataDaProgramacao: {
        prop: "startDate",
        type: Date,
      },
      HoraInicio: {
        prop: "startHour",
        type: String,
      },
      HoraFim: {
        prop: "endHour",
        type: String,
      },
      Ordem: {
        prop: "order",
        type: String,
      },
      Imagem1: {
        prop: "picture",
        type: String,
      },
      Imagem2: {
        prop: "picture2",
        type: String,
      },
      Imagem3: {
        prop: "picture3",
        type: String,
      },
      Imagem4: {
        prop: "picture4",
        type: String,
      },
      Imagem5: {
        prop: "picture5",
        type: String,
      },
      TipoOuLocalDaProgramacao: {
        prop: "typeOrLocation",
        type: String,
      },
      CorDaProgramacao: {
        prop: "color",
        type: String,
      },
      Palestrantes: {
        prop: "palestrantes",
        type: String,
      },
      Grupos: {
        prop: "groups",
        type: String,
      },
    };

    let count = 1;

    const readXlsx = async () => {
      const { rows } = await readXlsxFile(selectedFiles[0], { schema });

      const validateRows = rows.map((row, i) => allExcelColumns(row, i));

      setTotalRows(validateRows?.length);

      const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
      const header = rowsWithoutSchema[0];
      const schemaCreate = Object.keys(schema).filter(
        (key) => key !== "EventoID",
      );

      function isEqual(schema, header) {
        if (schema.length !== header.length) return false;

        return (
          schema.every((item) => header.includes(item)) &&
          header.every((item) => schema.includes(item))
        );
      }
      if (!isEqual(schemaCreate, header)) {
        setErrors([]);
        setModalErrors(true);
        return;
      }

      const validAgenda = await getValidateAgenda(
        validateRows,
        idEvent,
        "create",
      );
      if (validAgenda.length > 0) {
        setErrors(validAgenda);
        setModalErrors(true);
        return;
      }

      for (const row of validateRows) {
        if (importActivated.current === true) {
          await importScheduleService(row, validateRows.length);
        }
      }
    };

    readXlsx();

    async function importScheduleService(row, totalRows) {
      await importSchedule({
        eventId: idEvent,
        startDate: moment(row.startDate)
          .format()
          .replace("00:00:00-03:00", "00:01"),
        startHour: row.startHour,
        endHour: row.endHour,
        title: row.title,
        description: row.description,
        typeOrLocation: row.typeOrLocation,
        color: row.color,
        ordem: row.order ? Number(row.order) : null,
        picture: row.picture,
        picture2: row.picture2,
        picture3: row.picture3,
        picture4: row.picture4,
        picture5: row.picture5,
        expireDate: row.expireDate,
        palestrantes: row.palestrantes,
        groups: row.groups,
        jwt: token,
      })
        .then((e) => {
          if (e.message === "created") {
            setTotalSended(count++);
          }
          // if (totalRows === ++index) {
          //   setBtnCancel(false);
          // }
          if (count === totalRows || (count === 2 && totalRows === 1)) {
            setsuccess_dlg(true);
            // props.data[0].refetch();
          }
        })
        .catch((error) => console.log(error));
    }
  }

  return (
    <div
      isOpen={isOpen}
      toggle={() => toggleBackdrop()}
      autoFocus={true}
      centered={true}
    >
      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            toggle();
            setsuccess_dlg(false);
          }}
        >
          {"O arquivo foi enviado com sucesso!"}
        </SweetAlert>
      ) : null}
      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBr}
          typeImport="create"
        />
      )}
      {/* <ModalHeader toggle={toggle}>Importação Agenda</ModalHeader> */}
      <div className="m-1 p-0">
        <Card className="p-1">
          <CardBody className="m-1 p-2">
            <CardText className="mb-2 p-10">
              O arquivo a ser importado deve seguir este{" "}
              <a href={ModeloUpload} download="modelo_agenda.xlsx">
                Modelo
              </a>
              , não modifique seu cabeçalho.
            </CardText>

            <Form>
              {selectedFiles.length === 0 && (
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles);
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-1"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-4">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                          <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                        </div>
                      </div>
                    </div>
                  )}
                </Dropzone>
              )}
              <div className="dropzone-previews mt-0" id="file-previews">
                {selectedFiles.map((f, i) => {
                  return (
                    <Card
                      className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                      key={i + "-file"}
                    >
                      <div className="p-1">
                        <Row className="align-items-center">
                          <Col xs="11">
                            <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                          </Col>
                          <Col xs="1">
                            <span
                              style={{
                                fontSize: "16px",
                                color: "red",
                                fontWeight: "700",
                              }}
                              className="mdi mdi-close"
                              onClick={() => setselectedFiles([])}
                            />
                          </Col>
                        </Row>
                        {importActivated.current && (
                          <Row className="align-items-center">
                            <Col>
                              <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </Card>
                  );
                })}
              </div>
            </Form>

            <div className="text-center mt-3">
              <p style={{ color: "red" }}>{imgError}</p>
              <button
                type="button"
                disabled={!btnSend}
                className="btn btn-primary waves-effect waves-light"
                onClick={() => uploadService()}
              >
                Enviar Programação
              </button>
              <button
                type="button"
                className="btn btn-danger mx-1"
                disabled={!btnCancel}
                onClick={() => cancelImport()}
              >
                Cancelar
              </button>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
